import { PickersActionBarProps } from '@mui/x-date-pickers/PickersActionBar';
import { Button, DialogActions, } from '@mui/material';


export const CustomDatePickerActionBar = (props: PickersActionBarProps) => {
    const { onAccept, onClear, onCancel } = props;

    return (
        <DialogActions>
            <Button onClick={onClear} color="secondary">
                Clear
            </Button>
            <Button onClick={onCancel}>
                Cancel
            </Button>
            <Button onClick={onAccept}>
                Ok
            </Button>
        </DialogActions>
    );
};